<template>
	<!-- 公共按钮 -->
	<div class="contt" >
		<el-tooltip class="item" effect="dark" content="新增" placement="bottom">
			<el-button icon="el-icon-folder-add" circle @click="$emit('add')" :type="newblock?'success':'info'" :disabled="!newblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="查询" placement="bottom">
			<el-button icon="el-icon-search" circle @click="$emit('search')" :type="searchblock?'primary':'info'" :disabled="!searchblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="删除" placement="bottom">
			<el-button icon="el-icon-delete" circle @click="$emit('del')" :type="delblock?'danger':'info'" :disabled="!delblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
			<el-button icon="el-icon-refresh-right" circle @click="$emit('reflash')" :type="reflashblock?'warning':'info'" :disabled="!reflashblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="打印" placement="bottom">
			<el-button icon="el-icon-printer" circle @click="$emit('print')" :type="printblock?'success':'info'" :disabled="!printblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="导入" placement="bottom">
			<el-button icon="el-icon-upload2" circle @click="$emit('imp')" :type="impblock?'warning':'info'" :disabled="!impblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="导出" placement="bottom">
			<el-button icon="el-icon-download" circle @click="$emit('exps')" :type="expsblock?'warning':'info'" :disabled="!expsblock"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="编辑" placement="edit">
			<el-button icon="el-icon-edit" circle @click="$emit('edit')" :type="edit?'primary':'info'" :disabled="!edit"></el-button>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="保存" placement="bottom">
			<el-button icon="el-icon-document" circle @click="$emit('save')" :type="save?'primary':'info'" :disabled="!save"></el-button>
		</el-tooltip>
	</div>
</template>

<script>
export default {
	name: 'buttonlist',
	data() {
		return {
		};
	},
	props: {
		queryData: {
			type: Array,
			default: () => []
		},
		isVisible: {
			type: Boolean,
			default: false
		},
		newblock: {
			type: Boolean,
			default: false
		},
		searchblock: {
			type: Boolean,
			default: false
		},
		delblock: {
			type: Boolean,
			default: false
		},
		reflashblock: {
			type: Boolean,
			default: false
		},
		printblock: {
			type: Boolean,
			default: false
		},
		impblock: {
			type: Boolean,
			default: false
		},
		expsblock: {
			type: Boolean,
			default: false
		},
		edit: {
			type: Boolean,
			default: false
		},
        save: {
            type: Boolean,
            default: false
		}
	},
	mounted: function() {
		/* var users = sessionStorage.getItem('userData');
			users = JSON.parse(users);
			this.user = users; */
	},
	methods: {
	}
};
</script>

<style>
.contt{
	position: fixed;
	height: 60px;
	top: 0px;
	line-height: 60px;
	right: 120px;
	z-index: 1;
}
</style>
